var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-multiple-group--close-geometric-human-multiple-person-up-user",
    opacity: 0.8,
    clipPath: "url(#clip0_30_50)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user-multiple-group--close-geometric-human-multiple-person-up-user_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1429 9.64293C17.1429 13.1933 14.2647 16.0715 10.7143 16.0715C7.16389 16.0715 4.28571 13.1933 4.28571 9.64293C4.28571 6.09253 7.16389 3.21436 10.7143 3.21436C14.2647 3.21436 17.1429 6.09253 17.1429 9.64293ZM10.7143 18.2143C4.79696 18.2143 0 23.0113 0 28.9286C0 29.5202 0.479696 30 1.07143 30H20.3571C20.9489 30 21.4286 29.5202 21.4286 28.9286C21.4286 23.0113 16.6316 18.2143 10.7143 18.2143ZM28.9288 30H23.952C24.0531 29.6606 24.1074 29.3008 24.1074 28.9286C24.1074 24.5548 22.0108 20.6708 18.7678 18.2266C18.9395 18.2184 19.1122 18.2143 19.2859 18.2143C25.2032 18.2143 30.0002 23.0113 30.0002 28.9286C30.0002 29.5202 29.5204 30 28.9288 30ZM19.2859 16.0715C18.6393 16.0715 18.0151 15.976 17.4264 15.7985C18.9138 14.1775 19.8216 12.0162 19.8216 9.64293C19.8216 7.26961 18.9138 5.10832 17.4264 3.48738C18.0151 3.3098 18.6393 3.21436 19.2859 3.21436C22.8362 3.21436 25.7145 6.09253 25.7145 9.64293C25.7145 13.1933 22.8362 16.0715 19.2859 16.0715Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_50"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.bf64773296caa813e7d35228e289100a.svg";
export { ForwardRef as ReactComponent };